define([
	"dojo/_base/declare",
	"csi/widget/RadioToggleButton",
	"./ToolbarPlugin"
], function(declare,RadioToggleButton,ToolbarPlugin) {
	return declare([RadioToggleButton, ToolbarPlugin], {
		"class": 'csi-toolbar-radio-button',

		postMixInProperties: function() {
			// summary: set appearance based on action
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		startup: function() {
			// summary: set the initial default value
			this.set("checked", this.defAction.m_bToggle, false);
			return this.inherited(arguments);
		},

		onChange: function(/*Object*/value, /*Action*/action) {
			// summary: invoke action for change
			// NOTE: for some reason, Dojo triggers onChange event when button is disabled, so make sure to check for that here
			if (!this.get("disabled") && value) {
				this._invokeAction(action || this.defAction, null, {
					actionValue: value
				});
			}
		},

		onClick: function(/*Event*/e) {
			// summary: ignore this event in favor of onChange
			// this will prevent the toggle buttons from toggling off if its already checked (prevent multiple clicks on same button)
			if(!this.checked){
				e.stopPropagation();
				e.preventDefault();
				return false;
			}

			this.defAction.m_bToggle = true;
			e.stopPropagation();
			return true;
		}
	});
});